import * as React from 'react';
import { connect } from 'react-redux';
import { withSiteData } from 'react-static';

import LogoRowComponent from '../../components/LogoRow/LogoRow';
import { RootState } from '../../RootState';
import { Language } from '../Localization/localizationDuck';
import { SiteProps } from '../../SiteProps';

interface LogoRowProps extends SiteProps {
  language: Language;
}

const LogoRow: React.SFC<LogoRowProps> = ({ language, logoRowLocale }) => (
  <LogoRowComponent currentLanguage={language} locale={logoRowLocale[language]} />
);

const mapStateToProps = (state: RootState) => ({
  language: state.localization.language,
});

export default withSiteData(connect(mapStateToProps)(LogoRow));



// WEBPACK FOOTER //
// /www/client/src/containers/LogoRow/LogoRow.tsx